import classNames from 'classnames'
import { ClassProp } from 'components/types/common'
import React from 'react'
import styles from './Header.module.scss'

export const Header = ({ className }: ClassProp) => {
  return <div className={classNames(styles.header, className)}></div>
}
